module.exports = __webpack_public_path__ + "static/media/event_recovery.9ee3286e.png";